module.exports = __webpack_public_path__ + "img/202409181550265776nx.e17edd6d.png";